/**
 * 流程审批公共组件（flowable）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/flowable/ 下 审批按钮/审批弹窗/审批历史组件、
 *          流程定义设计器（modeler）、test_demo 示例页面
 * 术语：审批=Approval，流程=Process，办理=Handle，退回=Return，
 *       撤回=Withdraw，流程图=Flow Chart，审批意见=Approval Opinion
 */
export default {
  // ── 审批操作组件（ActApplyBtn / ActCancelBtn / ActHandleBtn / ActHandleModal / ActHandleCheckModal / ActPassBtn）──
  '提交申请': 'Submit Application',
  '必须传入参数dataId': 'Parameter dataId is required',
  '撤回': 'Withdraw',
  '确认撤回': 'Confirm Withdrawal',
  '撤回原因': 'Withdrawal Reason',
  '处理': 'Handle',
  '确认无误并重新提交？': 'Confirm and resubmit?',
  '处理意见': 'Approval Opinion',
  '请输入200个字符以内': 'Please enter no more than 200 characters',
  '退回节点': 'Return Node',
  '无可退回节点！': 'No node to return to!',
  '下个节点审批候选人': 'Next Node Approval Candidates',
  '请选择下个节点审批候选人': 'Select next node approval candidates',
  '未知类型type，参见 handleType': 'Unknown type, see handleType',
  '未知类型type,参见 handleType': 'Unknown type, see handleType',
  '确认重新提交': 'Confirm Resubmission',
  '审批通过': 'Approved',
  '审批驳回': 'Reject',
  '审批退回': 'Return',
  '请输入审批意见！': 'Please enter the approval opinion!',
  '请选择下个节点审批人！': 'Please select the next node approver!',
  '请选择退回节点！': 'Please select a return node!',
  '重新提交': 'Resubmit',
  '流程定义': 'Process Definition',
  '请先选择流程定义!': 'Please select a process definition first!',
  '请选择流程定义！': 'Please select a process definition!',
  '确定通过吗?': 'Are you sure you want to approve?',
  '通过': 'Approve',
  '驳回': 'Reject',
  '退回': 'Return',
  '操作成功': 'Operation successful',
  '操作失败': 'Operation failed',
  '提交': 'Submit',
  '取消': 'Cancel',
  // ── 审批历史组件（ActHistoricDetailBtn / TaskActHistoricDetailBtn / HistoricDetail / TaskTasktempHistoricDetail）──
  '审批历史': 'Approval History',
  '流程实例ID不存在': 'Process instance ID does not exist',
  '流程图': 'Flow Chart',
  '流程审批进度历史': 'Approval Progress History',
  '待办中。。。': 'Pending...',
  '实际办理人：': 'Actual Handler: ',
  '接收时间：': 'Received At: ',
  '办结时间：': 'Completion Time: ',
  '通过：': 'Approved: ',
  '退回：': 'Returned: ',
  '驳回：': 'Rejected: ',
  '【会签中】': '[Countersigning]',
  // ── 流程定义设计器（modeler/modelerDesign）──
  '流程名称': 'Process Name',
  '请输入名称': 'Please enter name',
  '流程分类': 'Process Category',
  '请选择流程分类': 'Select process category',
  '请选择': 'Please select',
  '激活': 'Activate',
  '搜索': 'Search',
  '重置': 'Reset',
  '新增流程定义': 'Add Process Definition',
  '流程定义id': 'Process Definition ID',
  '流程标识Key': 'Process Key',
  '流程版本': 'Process Version',
  '状态': 'Status',
  '挂起': 'Suspend',
  '部署时间': 'Deployed At',
  '操作': 'Action',
  '更多操作': 'More Actions',
  '编辑': 'Edit',
  '删除': 'Delete',
  '返回': 'Back',
  '新增流程': 'Add Process',
  '编辑流程图': 'Edit Flow Chart',
  '获取流程图失败！': 'Failed to get flow chart!',
  '警告': 'Warning',
  '是否确认删除流程定义编号为"{id}"的数据项?': 'Are you sure you want to delete the process definition with ID "{id}"?',
  '确定': 'OK',
  '删除成功': 'Deleted successfully',
  '删除失败': 'Deletion failed',
  // ── test_demo 示例页面（TestDemoList / TestDemoForm / TestDemoModal）──
  '用户名': 'Username',
  '请输入用户名': 'Please enter the username',
  '请输入用户名!': 'Please enter the username!',
  '性别': 'Gender',
  '请选择性别': 'Select gender',
  '年龄': 'Age',
  '请输入年龄': 'Please enter age',
  '描述': 'Description',
  '生日': 'Birthday',
  '请选择生日': 'Please select the birthday',
  '用户编码': 'Customer Code',
  '请输入用户编码': 'Please enter customer code',
  '头像': 'Avatar',
  '附件': 'Attachment',
  '城市': 'City',
  '请选择省市区': 'Select province/city/district',
  '请输入省市区': 'Please enter province/city/district',
  '请选择checkbox': 'Select checkbox',
  '下拉多选': 'Multi Select',
  '请选择下拉多选': 'Select multi select',
  '搜索下拉': 'Search Select',
  '请选择搜索下拉': 'Select search select',
  '下拉字典表': 'Dict Table Select',
  '弹窗': 'Popup',
  '请输入弹窗': 'Please enter popup',
  '查询': 'Query',
  '收起': 'Collapse',
  '展开': 'Expand',
  '新增': 'Add',
  '测试用户表': 'Test User Table',
  '测试用户表管理页面': 'Test User Table Management Page',
  '导出': 'Export',
  '导入': 'Import',
  '已选择': 'Selected',
  '项': 'items',
  '清空': 'Clear',
  '无图片': 'No Image',
  '无文件': 'No File',
  '下载': 'Download',
  '关联流程': 'Related Process',
  '更多': 'More',
  '详情': 'Details',
  '确定删除吗?': 'Are you sure you want to delete?',
  '流程状态': 'Process Status',
  '待处理节点': 'Pending Node',
  '关闭': 'Close'
}
